/**
 * Generated by '@kontent-ai/model-generator@6.5.1'
 */
export const roles = {
    /**
     * Project manager
     */
    projectManager: {
        codename: 'project-manager',
        id: 'e18dc706-4897-4426-8849-5bac8f22b987',
        name: 'Project manager'
    }
} as const;
